module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Body_Text__And__Spacing_After"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-family": "BigNoodleTitling",
      "font-size": "2.50em"
    }
  }, [_vm._v("Praise for the Works of Joshua Bader")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph_1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph_1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Debut author Bader introduces readers to the Modern Knights series with an extremely impressive first novel of delicious urban fantasy with just a hint of romance. This fantastical thrill ride is filled with perfectly timed pop-culture references, stunning plot twists, and the snarky (and sometimes offensive) stylings of Colin’s inner voice. Well-researched and creatively presented humor and action perfectly blend with moral quandaries in this outstanding debut.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body__And__Centre_Alignment__And__Right_Indent__And__Line_Spacing__And__Tabs"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("- Publishers Weekly Starred Review")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body__And__Centre_Alignment__And__Right_Indent__And__Line_Spacing__And__Tabs"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body__And__Centre_Alignment__And__Right_Indent__And__Line_Spacing__And__Tabs"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“")]), _vm._v("Bader delivers another urban fantasy home run in TWO WIZARD ROULETTE. The book boasts both sharp wit and beautifully crafted emotional depth, and it’s extremely easy to fall headlong into the story.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body__And__Centre_Alignment__And__Right_Indent__And__Line_Spacing__And__Tabs"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("- Publishers Weekly Starred Review")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph_1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph_1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“I LOVED THIS BOOK. Did you see those caps? Yes, I'm that excited about it! Bader has written a great addition to the urban fantasy genre. His writing style has resulted in relatable characters who aren't all powerful (just like you and me). The resulting novel takes the reader on a wild ride from start to finish as you learn about Colin Fisher and his powers. Great stuff and can't wait for the second book!”")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body__And__Centre_Alignment__And__Right_Indent__And__Line_Spacing__And__Tabs__OPENPAR_1_CLOSEPAR_"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("- GoodReads Reviewer, Cora Burke")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Paragraphs__And__Centre_Alignment__And__Right_Indent__And__Line_Spacing__And__Tabs"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph_1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“I must say upfront, this book exceeded my expectations! It was a thrill from beginning to end. Excellent writing, a wonderful plot, and a wonderful cast of characters kept me up longer at night than I wanted to see what was going to happen to Colin. Very highly recommend.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body__And__Centre_Alignment__And__Right_Indent__And__Line_Spacing__And__Tabs__OPENPAR_1_CLOSEPAR_"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("- Librarian, Penny Noble")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body__And__Centre_Alignment__And__Right_Indent__And__Line_Spacing__And__Tabs__OPENPAR_1_CLOSEPAR_"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body__And__Centre_Alignment__And__Right_Indent__And__Line_Spacing__And__Tabs__OPENPAR_1_CLOSEPAR_"
  }, [_c('span', [_vm._v("“I didn’t dare close my eyes after reading FROSTBITE. I was wide awake, imagining those nasty monsters and wendigos that I’ve read about... You should get this book. It’s terrific and exhilarating!” ")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body__And__Centre_Alignment__And__Right_Indent__And__Line_Spacing__And__Tabs__OPENPAR_1_CLOSEPAR_"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("- Coffeeholic Bookworm Blog")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body__And__Centre_Alignment__And__Right_Indent__And__Line_Spacing__And__Tabs__OPENPAR_1_CLOSEPAR_"
  }, [_c('span')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 66
// module chunks = 0